
<div class="preview-container">

  <!-- Loading -->
  @if(loading){
  <div class="loading">
    <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    <span>Loading…</span>
  </div>
  }

  <!-- Error -->
  @if(error && !loading){
  <div class="error">
    <mat-icon>error</mat-icon>
    <span>{{ error }}</span>
  </div>
  }

  <!-- Office Docs (Excel, Word, PowerPoint) -->
  @if(safeUrl && isOfficeMime(mime!)){
  <iframe class="office-doc"
          [src]="safeUrl"
          referrerpolicy="no-referrer">
  </iframe>
  }

  <!-- PDF -->
  @if(mime==='application/pdf'){
  <object [attr.data]="safeUrl"
          type="application/pdf"
          class="pdf-viewer">
    <iframe [src]="safeUrl" class="pdf-viewer"></iframe>
  </object>
  }
  <!-- Image -->
  @if(mime?.startsWith('image/')){
  <img [src]="safeUrl"
       class="image-viewer" />
  }


  <!-- Fallback -->
  @if(!loading && !safeUrl && !mime?.startsWith('image/') && !mime?.includes('pdf') && !isOfficeMime(mime!)){
  <div>
    <mat-icon>insert_drive_file</mat-icon>
    <p>No inline preview. Use Download.</p>
  </div>
  }
</div>
